<template>
  <form  action="" id="form" enctype="multipart/form-data">


    <div class="login-register">
      <div class="form-ipt">
        <h1 class="logo"><router-link to="/"><img :src="require('@/assets/images/logo.png')" alt=""></router-link></h1>
        <div class="form-title">验证码登录</div>
        <div class="form-cont">
          <div class="no-register" v-if="isRegister"><i class="el-icon-warning"></i> 该手机号尚未注册，你可以<router-link to="/register">去注册</router-link></div>
          <el-input placeholder="请输入手机号" type="text" name="registerPhoneNum" id="registerPhoneNum"  v-on:input="checkTimes" v-model="registerPhoneNum" autocomplete="on">

            <!--        <el-select v-model="quSelect" slot="prepend" placeholder="请选择区号">-->
            <!--          <el-option v-for="(item, index) in quSelectList" :key="index" :label="item.label" :value="item.value"></el-option>-->
            <!--        </el-select>-->
          </el-input>
          <input type="hidden" v-for="(item,index) of inputs"  :name="item.name"  v-model="inputs[index].value" :key="index">
          <div class="form-item" v-if="registerImgCodeShow">
            <el-input class="left-ipt" v-model="registerImgCode" placeholder="请输入验证码"></el-input>
            <img class="right-btn" :src="registerCheckImg" alt="" v-on:click="check_code">
          </div>
          <div class="form-item">
            <el-input class="left-ipt" v-model="registerYzm" placeholder="请输入6位短信验证码"></el-input>
            <el-button
                    class="right-btn"
                    :type="time === 0 ? 'primary' : 'info'"
                    :disabled="time === 0 ? false : true"
                    @click="setTime"
            >
              {{time === 0 ? '发送验证码' : time + '秒后重发'}}
            </el-button>
          </div>
          <div class="left-right-two">
            <div class="left">
              <router-link class="blue" :to="passLoginUrl">密码登录</router-link>
            </div>
            <div class="right">
              <router-link :to="registerUrl">密码注册</router-link>
            </div>
          </div>
          <!--        <div class="agree">-->
          <!--          <el-checkbox v-model="xieyi">我已阅读并接受</el-checkbox>-->
          <!--          <span class="xieyi">《人人动画网用户使用协议》</span>及-->
          <!--          <span class="xieyi">《隐私政策》</span>-->
          <!--        </div>-->
          <!--        <div class="login-btn">-->
          <!--          <el-button  class="btn" size="medium" :loading="loading" @click="login()">登录/注册</el-button>-->
          <!--        </div>-->
          <div class="login-btn">
            <el-button class="btn newbtn" size="medium" :loading="loading" @click="login()">登 录</el-button>
          </div>
          <div class="back-index"><router-link to="/">返回首页</router-link></div>
            <div class="sanfang" v-if="!isMobile">
                <div class="tit">
                    <span>使用第三方平台登录</span>
                </div>
                <div class="list">
                    <a class="item qq"  @click="qqLoginClick" id="qqLoginBtn"></a>
                    <a class="item wechat" href="https://open.weixin.qq.com/connect/qrconnect?appid=wx9889a16d40aac1b8&redirect_uri=http%3a%2f%2fwww.renrendonghua.com%2fauth%2fauthWeiXin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"></a>
                    <a class="item weibo" href="https://api.weibo.com/oauth2/authorize?client_id=2471057307&response_type=code&redirect_uri=http://www.renrendonghua.com/auth/authWeiBo"></a>
                </div>
            </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios';
  import vue from 'vue';
  vue.prototype.$axios = axios;
  import qs from 'qs';
  vue.prototype.qs = qs;
  import VueCookies from 'vue-cookies'
  vue.use(VueCookies);
  import updateTdk from "@/utils/tdk";
  export default {
    components: {
    },
      tdk() {
          return {
              title: this.headTitle,
              description: this.headDesc,
              keywords: this.headKeywords,
              ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
          };
      },
    data () {
      return {
          passLoginUrl:"/passlogin",
          registerUrl:"/register",
          headTitle: "登录-人人动画网【官网】",
          headKeywords: "登录-人人动画网【官网】",
          headDesc: "登录-人人动画网【官网】",
          isMounted: false ,//for control not ssr render
        inputs:[],
        registerImgCodeShow:false,
        loading:false,
        quSelect: '中国 +86',
        quSelectList: [
          {
            label: '中国 +86',
            value: 1
          },
          {
            label: '中国香港 +852',
            value: 2
          },
          {
            label: '中国澳门 +853',
            value: 3
          },
          {
            label: '中国台湾 +886',
            value: 4
          },
          {
            label: '美国 +1',
            value: 5
          },
          {
            label: '日本 +81',
            value: 6
          },
          {
            label: '韩国 +82',
            value: 7
          }
        ],
        actionUrl:"",
        registerPhoneNum: '',
        registerImgCode: '',
        registerCheckImg: '',
        registerYzm: '',
        time: 0,
        fromUrl:"",
        fromQuery:"",
        xieyi: true,
        isRegister:false,
        timer:null,
        isWeiXin:false,
        isMobile:false,
      }
    },
      serverPrefetch() {
          updateTdk.call(this);
      },
    created:function(){


    },
    mounted() {
        this.isMounted = true;

      let _this=this;
        _this.checkIsMobile();
        _this.checkIsWeiXin();
        if(window.location.href.indexOf("callback")!=-1){
            let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
            this.fromUrl=decodeURIComponent(url);
            this.passLoginUrl="/passlogin?callback="+this.fromUrl
            this.registerUrl="/register?callback="+this.fromUrl
        }else{
            this.fromUrl='http://www.renrendonghua.com';
        }
        console.log("this.fromUrl",this.fromUrl)
        _this.$cookies.set("formUrl",this.fromUrl,60 * 60,"/",process.env.VUE_APP_DOMAIN);
        console.log("_this.$cookies",this.$cookies.get("formUrl"))
        console.log("_this.JSESSIONID",this.$cookies.get("JSESSIONID"))
        let url='/api/checkLogin?time='+new Date().getMilliseconds();
        this.$axios.get(url).then(function(result){
          if(result.status ==200 && result.data.isLogin){
            window.location.href=_this.fromUrl;
          }
        })
        this.check_code();
        this.checkTimes();
      if(this.fromUrl!=""){
        let cs = this.fromUrl.split('?')[1];
        if(cs!=undefined){
          let arr= cs.split('&');
          if(arr.length>0){
            arr.forEach(function (e) {

              console.log("aaaa",e)
              let nv= e.split("=")
              console.log("bbbbb",nv)
              // console.log("bbbbb",_this.fromUrl)
              _this.inputs.push({name:nv[0],value:nv[1]})
            })
            console.log(_this.inputs)
          }
          console.log("cs",arr)
        }
      }



    },
    methods: {
        weixinLogin(){
            window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9889a16d40aac1b8&redirect_uri=http%3a%2f%2fwww.renrendonghua.com%2fauth%2fauthWeiXin&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect"

        },

        qqLoginClick() {
           window.location.href="https://graph.qq.com/oauth2.0/authorize?client_id=101866307&response_type=token&scope=all&redirect_uri=http%3A%2F%2Fwww.renrendonghua.com%2Fauth%2FauthQQ";
            // 直接弹出授权页面，授权过后跳转到回调页面进行登录处理
            // eslint-disable-next-line no-undef
            // QC.Login.showPopup({
            //     appId:"101866307",
            //     redirectURI:"http://www.renrendonghua.com/auth/authQQ"  //登录成功后会自动跳往该地址
            // });
          //qq官方登录按钮
          // QC.Login({
          //   btnId:"qqLoginBtn"	//插入按钮的节点id
          // })
            // window.location.href="http://www.renrendonghua.com/auth/autoLoginQQ"
          // this.timer = setInterval(this.checkQQLogin, 1000);
        },
      checkTimes(){

        if(localStorage.getItem('captchaCheck')!=null&&parseInt(localStorage.getItem('captchaCheck'))>=3){
          this.registerImgCodeShow=true
          console.log("尝试发送"+localStorage.getItem('captchaCheck')+"次验证码,超过3次")
        }else if(localStorage.getItem('captchaCheck')==null){
          window.localStorage.setItem('captchaCheck',"0");
          this.registerImgCodeShow=false
          console.log("尝试发送"+localStorage.getItem('captchaCheck'))
        }
      },
      // 倒计时
      setTime () {
        let captchaCheck=0;
        let _this=this;


        let postData = {
          'mobile':this.registerPhoneNum,
          'captchaValue':this.registerImgCode
        }
        if(!this.registerPhoneNum){
          _this.$message({
            message: '手机号码不能为空',
            type: 'warning'
          });
          return false;
        }else {
          const reg = /^1[1|2|3|4|5|6|7|8|9][0-9]\d{8}$/
          if (!reg.test(this.registerPhoneNum)) {
            _this.$message({
              message: '手机号码格式有误',
              type: 'warning'
            });
            return false;
          }else{
            if(localStorage.getItem('captchaCheck')==null){
              localStorage.setItem('captchaCheck',1);
            }else{
              localStorage.setItem('captchaCheck',parseInt(localStorage.getItem('captchaCheck'))+1);
              if(parseInt(localStorage.getItem('captchaCheck'))>3){
                captchaCheck=1
                _this.registerImgCodeShow=true
              }else{
                console.log("尝试发送"+localStorage.getItem('captchaCheck')+"次验证码，小于三次")
              }
            }

            let url='/api/checkcode?time='+ new Date().getMilliseconds()+"&captchaCheck="+captchaCheck;
            this.$axios.post(url, qs.stringify(postData)).then(function(result){
              console.log("result.data",result);
              if(result.data.code=="23"){
                _this.$message({
                  message: '由于您的操作过于频繁，系统已暂停登录服务，请您明天再来尝试',
                  type: 'warning'
                });
                return false;
              }
              if(result.data==1){
                _this.$message({
                  message: '图形验证码不能为空',
                  type: 'warning'
                });
                return false;
              }
              if(result.data==2){
                _this.$message({
                  message: '图形验证码填写错误',
                  type: 'warning'
                });
                return false;
              }
              if(result.data==-1){
                _this.time = 60
                _this.interval = setInterval(() => {
                  _this.time = _this.time - 1
                  if(_this.time === 0) {
                    clearInterval(_this.interval)
                  }
                }, 1000)
              }
            })
          }
        }


      },

      check_code:function () {
        let _this=this;
        let time= new Date().getMilliseconds();
        let url='/api/checkcode?time='+time;
        this.$axios.get(url,{responseType: 'arraybuffer'}).then(function(result){
          let img_url='data:image/png;base64,' + btoa(new Uint8Array(result.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          _this.registerCheckImg=img_url;
        })
      },
      login:function () {
        let domain = document.domain;
        console.log(domain)
        let _this=this;
        _this.loading=true;
        let url='/api/login?time='+new Date().getMilliseconds();
        let fast_login_url='http://cas.21teacher.com/smsCodeLoginCheck?time='+new Date().getMilliseconds();
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        let source = 'pc';
        if(flag){
          source = 'h5'
        }
        let postData2 = {
          'phonenum':this.registerPhoneNum,
          'smsCode':this.registerYzm,
        }
        let postData = {
          'mobile':this.registerPhoneNum,
          'captchaValue':this.registerYzm,
          'source' : source,
        }
        if(!this.xieyi){
          _this.$message({
            message: '请先阅读并接受用户协议',
            type: 'warning'
          });
          _this.loading=false;
          return false;
        }
        if(!this.registerPhoneNum){
          _this.$message({
            message: '手机号码不能为空',
            type: 'warning'
          });
          _this.loading=false;
          return false;
        }else if(!this.registerYzm){
          _this.$message({
            message: '手机验证码不能为空',
            type: 'warning'
          });
          _this.loading=false;
          return false;
        }else{
          this.$axios.post(url, qs.stringify(postData)).then(function(result1){
            if(result1.data.code==1){
              let message=result1.data.message

              _this.$axios.post(fast_login_url, qs.stringify(postData2)).then(function(result){
                console.log(result.data)
                if(result.data.code==10){
                  let d={"userId":result.data.userModel.id};
                  let dataBoardUrl="/databoardapi/loginLog/add";
                  _this.$axios.post(dataBoardUrl,qs.stringify(d)).then(function () {
                    console.log("登录日志插入")
                  });
                  localStorage.removeItem('captchaCheck')
                  let sso_sessionid =result.data.token;
                  let user_id=result.data.userModel.id;
                  let user_name=result.data.userModel.userName;
                  console.log(sso_sessionid)
                  let checkurl='/api/checkLogin?sso_sessionid='+sso_sessionid+'&time='+ new Date().getMilliseconds();
                  _this.$axios.get(checkurl).then(function(result2){
                    if(result2.data.isLogin&&result2.data.casFastUserModel!=null){
                      _this.global.setIsLogin(true);
                      _this.$cookies.set("userId",user_id,0,"/",'.renrendonghua.com');
                      _this.$cookies.set("user_id",user_id,0,"/",process.env.VUE_APP_DOMAIN);
                      _this.$cookies.set("user_name",user_name,0,"/",process.env.VUE_APP_DOMAIN);
                      let updateLoginUrl="/rrbi/updateLoginUserInfo?time="+ new Date().getMilliseconds();
                      _this.$axios.get(updateLoginUrl).then(function () {
                        if (message==4||message==5){
                          let noticUrl="/rrbi/notifications/saveRegisterNotify?userId="+result2.data.casFastUserModel.id+"&userName="+result2.data.casFastUserModel.name+"&objectType="+message
                          _this.$axios.get(noticUrl).then(function () {
                            if(_this.fromUrl!=""){
                              window.location.href=_this.fromUrl
                              // document.getElementById("form").setAttribute("action",_this.fromUrl);
                              // document.getElementById("form").setAttribute("method","post");
                              // document.getElementById("form").submit()
                            }else{
                              window.location.href="http://www.renrendonghua.com"
                              // document.getElementById("form").setAttribute("action","http://www.renrendonghua.com");
                              // document.getElementById("form").setAttribute("method","post");
                              // document.getElementById("form").submit()

                            }
                          })
                        }else{
                          if(_this.fromUrl!=""){
                            window.location.href=_this.fromUrl
                            // document.getElementById("form").setAttribute("action",_this.fromUrl);
                            // document.getElementById("form").setAttribute("method","post");
                            // document.getElementById("form").submit()

                          }else{
                            window.location.href="http://www.renrendonghua.com"
                            // document.getElementById("form").setAttribute("action","http://www.renrendonghua.com");
                            // document.getElementById("form").setAttribute("method","post");
                            // document.getElementById("form").submit()
                          }
                        }
                      })


                    }else{
                      _this.$message({
                        message: '登录失败',
                        type: 'warning'
                      });
                      _this.loading=false;
                    }
                  })
                }else{
                  _this.$message({
                    message: '登录失败',
                    type: 'warning'
                  });
                  _this.loading=false;
                }

              })
            }else{
              console.log(result1.data)
              if(result1.data.message=="手机号没注册尚未注册"){
                _this.isRegister=true;
              }else{
                _this.$message({
                  message: '手机短信验证失败，请重新尝试',
                  type: 'warning'
                });
              }
              _this.loading=false;
              return false;
            }

          })
        }
      },
        checkIsMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            this.isMobile=flag;
        },
        checkIsWeiXin () {
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.indexOf('micromessenger') > -1) {
                this.isWeiXin=true;
                return true; // 是微信端
            } else {
                this.isWeiXin=false;
                return false;
            }
        },
    },
    // beforeRouteEnter(to, from, next) {
    //     next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
    //         console.log(to)
    //         console.log(from)
    //         console.log(from.query);
    //         console.log(document.referrer)
    //         // if(document.referrer!=''&&document.referrer.indexOf("http://www")==-1){
    //         // if(window.location.href.indexOf("http")!= -1){
    //         //   vm.fromUrl=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
    //         // vm.fromUrl=document.referrer;
    //         // }else{
    //         //   vm.fromUrl=from.path;
    //         //   vm.fromQuery=from.query;
    //         // }
    //
    //     })
    // },

    beforeDestroy () {
      clearInterval(this.interval)
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/login.less";
</style>
